import { zustandState } from "./zustandState";

export const useCompany = zustandState<string>('')